import { UserRegisterPageV2 } from "pages/authV2/UserRegisterPageV2";
import { lazy, Suspense } from "react";

const Loadable = (Component: any) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  //const { pathname } = useLocation();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component {...props} />
    </Suspense>
  );
};

export const pagesLoader = () => {
  const NscCollegePage = Loadable(
    lazy(() =>
      import("pages/students/nsc-colleges/NscCollegePage/NscCollegePage").then((module) => ({
        default: module.NscCollegePage,
      }))
    )
  );

  const HomePage = Loadable(
    lazy(() =>
      import("pages/HomePage/HomePage").then((module) => ({
        default: module.HomePage,
      }))
    )
  );

  const TestPage = Loadable(
    lazy(() =>
      import("pages/TestPage/TestPage").then((module) => ({
        default: module.TestPage,
      }))
    )
  );

  const The404Page = Loadable(
    lazy(() =>
      import("pages/The404Page/The404Page").then((module) => ({
        default: module.The404Page,
      }))
    )
  );

  const ThankYouPage = Loadable(
    lazy(() =>
      import("pages/ThankYouPage/ThankYouPage").then((module) => ({
        default: module.ThankYouPage,
      }))
    )
  );

  const LoginPage = Loadable(
    lazy(() =>
      import("pages/auth/LoginPage/LoginPage").then((module) => ({
        default: module.LoginPage,
      }))
    )
  );

  const LoginPageV2 = Loadable(
    lazy(() =>
      import("pages/authV2/LoginPageV2").then((module) => ({
        default: module.LoginPageV2,
      }))
    )
  );

  const ForgotCredentialPage = Loadable(
    lazy(() =>
      import("pages/auth/ForgotCredentialPage/ForgotCredentialPage").then((module) => ({
        default: module.ForgotCredentialPage,
      }))
    )
  );

  const ForgotCredentialPageV2 = Loadable(
    lazy(() =>
      import("pages/authV2/ForgotCredentialPageV2").then((module) => ({
        default: module.ForgotCredentialPageV2,
      }))
    )
  );

  const ResetPasswordPage = Loadable(
    lazy(() =>
      import("pages/auth/ResetPasswordPage/ResetPasswordPage").then((module) => ({
        default: module.ResetPasswordPage,
      }))
    )
  );
  const UserRegisterPage = Loadable(
    lazy(() =>
      import("pages/auth/UserRegisterPage/UserRegisterPage").then((module) => ({
        default: module.UserRegisterPage,
      }))
    )
  );
  const UserRegisterPageV2 = Loadable(
    lazy(() =>
      import("pages/authV2/UserRegisterPageV2").then((module) => ({
        default: module.UserRegisterPageV2,
      }))
    )
  );

  const UserManualPage = Loadable(
    lazy(() =>
      import("pages/UserManual/UserManualPage").then((module) => ({
        default: module.UserManualPage,
      }))
    )
  );

  const DeveloperPage = Loadable(
    lazy(() =>
      import("pages/cobro/developers/DeveloperPage/DeveloperPage").then((module) => ({
        default: module.DeveloperPage,
      }))
    )
  );

  const DeveloperListPage = Loadable(
    lazy(() =>
      import("pages/cobro/developers/DeveloperListPage/DeveloperListPage").then((module) => ({
        default: module.DeveloperListPage,
      }))
    )
  );

  const DeveloperBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/cobro/developers/DeveloperBulkUpdatePage/DeveloperBulkUpdatePage").then((module) => ({
        default: module.DeveloperBulkUpdatePage,
      }))
    )
  );

  const UserPage = Loadable(
    lazy(() =>
      import("pages/users/UserPage/UserPage").then((module) => ({
        default: module.UserPage,
      }))
    )
  );

  const UserListPage = Loadable(
    lazy(() =>
      import("pages/users/UserListPage/UserListPage").then((module) => ({
        default: module.UserListPage,
      }))
    )
  );

  const CobroSurveyExportPage = Loadable(
    lazy(() =>
      import("pages/cobro/survey-export/CobroSurveyExportPage").then((module) => ({
        default: module.CobroSurveyExportPage,
      }))
    )
  );

  const SurveyExportPage = Loadable(
    lazy(() =>
      import("pages/surveys/survey-export/SurveyExportPage").then((module) => ({
        default: module.SurveyExportPage,
      }))
    )
  );

  const SurveyResponseListPage = Loadable(
    lazy(() =>
      import("pages/cobro/survey-responses/SurveyResponseListPage/SurveyResponseListPage").then((module) => ({
        default: module.SurveyResponseListPage,
      }))
    )
  );

  const ApplicationListPage = Loadable(
    lazy(() =>
      import("pages/cobro/applications/ApplicationListPage/ApplicationListPage").then((module) => ({
        default: module.ApplicationListPage,
      }))
    )
  );

  const ApplicationPage = Loadable(
    lazy(() =>
      import("pages/cobro/applications/ApplicationPage/ApplicationPage").then((module) => ({
        default: module.ApplicationPage,
      }))
    )
  );

  const SurveyListPage = Loadable(
    lazy(() =>
      import("pages/cobro/surveys/SurveyListPage/SurveyListPage").then((module) => ({
        default: module.SurveyListPage,
      }))
    )
  );

  const SurveyPage = Loadable(
    lazy(() =>
      import("pages/cobro/surveys/SurveyPage/SurveyPage").then((module) => ({
        default: module.SurveyPage,
      }))
    )
  );

  const ContributorListPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributors/ContributorListPage/ContributorListPage").then((module) => ({
        default: module.ContributorListPage,
      }))
    )
  );

  const ContributorPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributors/ContributorPage/ContributorPage").then((module) => ({
        default: module.ContributorPage,
      }))
    )
  );

  const ContributorCreatePage = Loadable(
    lazy(() =>
      import("pages/match-main/contributors/ContributorCreatePage/ContributorCreatePage").then((module) => ({
        default: module.ContributorCreatePage,
      }))
    )
  );

  const ContributorBulkCreateMatchesPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributors/ContributorBulkCreateMatchesPage/ContributorBulkCreateMatchesPage").then(
        (module) => ({
          default: module.ContributorBulkCreateMatchesPage,
        })
      )
    )
  );

  const ContributorBulkMergePage = Loadable(
    lazy(() =>
      import("pages/match-main/contributors/ContributorBulkMergePage/ContributorBulkMergePage").then((module) => ({
        default: module.ContributorBulkMergePage,
      }))
    )
  );

  const ContributorEmploymentPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributor-employments/ContributorEmploymentPage/ContributorEmploymentPage").then(
        (module) => ({
          default: module.ContributorEmploymentPage,
        })
      )
    )
  );

  const SurveyResponseStudentPage = Loadable(
    lazy(() =>
      import("pages/cobro/survey-responses/SurveyResponseStudent/SurveyResponseStudentPage").then((module) => ({
        default: module.SurveyResponseStudentPage,
      }))
    )
  );

  const ContributorMatchPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributor-matches/ContributorMatchPage/ContributorMatchPage").then((module) => ({
        default: module.ContributorMatchPage,
      }))
    )
  );

  const ContributorMatchListPage = Loadable(
    lazy(() =>
      import("pages/match-main/contributor-matches/ContributorMatchListPage/ContributorMatchListPage").then(
        (module) => ({
          default: module.ContributorMatchListPage,
        })
      )
    )
  );

  const ContributorMatchBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/match-main/contributor-matches/ContributorMatchBulkUpdatePage/ContributorMatchBulkUpdatePage").then(
        (module) => ({
          default: module.ContributorMatchBulkUpdatePage,
        })
      )
    )
  );

  const ContributorMatchServiceListPage = Loadable(
    lazy(() =>
      import(
        "pages/match-utility/contributor-match-services/ContributorMatchServiceListPage/ContributorMatchServiceListPage"
      ).then((module) => ({
        default: module.ContributorMatchServiceListPage,
      }))
    )
  );

  const ContributorMatchServicePage = Loadable(
    lazy(() =>
      import(
        "pages/match-utility/contributor-match-services/ContributorMatchServicePage/ContributorMatchServicePage"
      ).then((module) => ({
        default: module.ContributorMatchServicePage,
      }))
    )
  );

  const PartnerListPage = Loadable(
    lazy(() =>
      import("pages/match-utility/partners/PartnerListPage/PartnerListPage").then((module) => ({
        default: module.PartnerListPage,
      }))
    )
  );

  const PartnerPage = Loadable(
    lazy(() =>
      import("pages/match-utility/partners/PartnerPage/PartnerPage").then((module) => ({
        default: module.PartnerPage,
      }))
    )
  );

  const PartnerCreatePage = Loadable(
    lazy(() =>
      import("pages/match-utility/partners/PartnerCreatePage/PartnerCreatePage").then((module) => ({
        default: module.PartnerCreatePage,
      }))
    )
  );

  const PublicApplicationPage = Loadable(
    lazy(() =>
      import("pages/public-forms/applications/PublicApplicationPage").then((module) => ({
        default: module.PublicApplicationPage,
      }))
    )
  );

  const PublicSurveyPage = Loadable(
    lazy(() =>
      import("pages/public-forms/surveys/PublicSurveyPage").then((module) => ({
        default: module.PublicSurveyPage,
      }))
    )
  );

  const PartnerIndirectCostPage = Loadable(
    lazy(() =>
      import("pages/match-utility/partner-indirect-costs/PartnerIndirectCostPage/PartnerIndirectCostPage").then(
        (module) => ({
          default: module.PartnerIndirectCostPage,
        })
      )
    )
  );

  const SubPartnerPage = Loadable(
    lazy(() =>
      import("pages/match-utility/sub-partners/SubPartnerPage/SubPartnerPage").then((module) => ({
        default: module.SubPartnerPage,
      }))
    )
  );

  const MatchReportPage = Loadable(
    lazy(() =>
      import("pages/match-main/reports/MatchReportPage/MatchReportPage").then((module) => ({
        default: module.MatchReportPage,
      }))
    )
  );

  const ExportPage = Loadable(
    lazy(() =>
      import("pages/reports/ExportPage/ExportPage").then((module) => ({
        default: module.ExportPage,
      }))
    )
  );

  const ObjectiveReportPage = Loadable(
    lazy(() =>
      import("pages/reports/ObjectiveReportPage/ObjectiveReportPage").then((module) => ({
        default: module.ObjectiveReportPage,
      }))
    )
  );

  const DashboardReportPage = Loadable(
    lazy(() =>
      import("pages/reports/DashboardReportPage/DashboardReportPage").then((module) => ({
        default: module.DashboardReportPage,
      }))
    )
  );

  const SurveyReportReportPage = Loadable(
    lazy(() =>
      import("pages/reports/SurveyReportReportPage/SurveyReportReportPage").then((module) => ({
        default: module.SurveyReportReportPage,
      }))
    )
  );

  const SurveyReportListPage = Loadable(
    lazy(() =>
      import("pages/cobro/survey-reports/SurveyReportListPage/SurveyReportListPage").then((module) => ({
        default: module.SurveyReportListPage,
      }))
    )
  );

  const SurveyReportPage = Loadable(
    lazy(() =>
      import("pages/cobro/survey-reports/SurveyReports/SurveyReportPage").then((module) => ({
        default: module.SurveyReportPage,
      }))
    )
  );

  const NonPersonnelListPage = Loadable(
    lazy(() =>
      import("pages/match-main/nonPersonnels/NonPersonnelListPage/NonPersonnelListPage").then((module) => ({
        default: module.NonPersonnelListPage,
      }))
    )
  );

  const NonPersonnelPage = Loadable(
    lazy(() =>
      import("pages/match-main/nonPersonnels/NonPersonnelPage/NonPersonnelPage").then((module) => ({
        default: module.NonPersonnelPage,
      }))
    )
  );

  const SuppliesDetailListPage = Loadable(
    lazy(() =>
      import("pages/match-utility/supplies-details/SuppliesDetailListPage/SuppliesDetailListPage").then((module) => ({
        default: module.SuppliesDetailListPage,
      }))
    )
  );

  const SuppliesDetailPage = Loadable(
    lazy(() =>
      import("pages/match-utility/supplies-details/SuppliesDetailPage/SuppliesDetailPage").then((module) => ({
        default: module.SuppliesDetailPage,
      }))
    )
  );

  const DataCenterFileListPage = Loadable(
    lazy(() =>
      import("pages/data-center/dataCenterFiles/DataCenterFileListPage/DataCenterFileListPage").then((module) => ({
        default: module.DataCenterFileListPage,
      }))
    )
  );

  const DataCenterFileViewPage = Loadable(
    lazy(() =>
      import("pages/data-center/dataCenterFiles/DataCenterFileViewPage/DataCenterFileViewPage").then((module) => ({
        default: module.DataCenterFileViewPage,
      }))
    )
  );

  const DataCenterFileCreatePage = Loadable(
    lazy(() =>
      import("pages/data-center/dataCenterFiles/DataCenterFileCreatePage/DataCenterFileCreatePage").then((module) => ({
        default: module.DataCenterFileCreatePage,
      }))
    )
  );

  const StaffListPage = Loadable(
    lazy(() =>
      import("pages/staff/staff/StaffListPage/StaffListPage").then((module) => ({
        default: module.StaffListPage,
      }))
    )
  );

  const StaffPage = Loadable(
    lazy(() =>
      import("pages/staff/staff/StaffPage/StaffPage").then((module) => ({
        default: module.StaffPage,
      }))
    )
  );

  const StudentListPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentListPage/StudentListPage").then((module) => ({
        default: module.StudentListPage,
      }))
    )
  );

  const StudentBulkCreateServicesPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentBulkCreateServicesPage/StudentBulkCreateServicesPage").then((module) => ({
        default: module.StudentBulkCreateServicesPage,
      }))
    )
  );

  const StudentPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentPage/StudentPage").then((module) => ({
        default: module.StudentPage,
      }))
    )
  );

  const StudentBulkMergePage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentBulkMergePage/StudentBulkMergePage").then((module) => ({
        default: module.StudentBulkMergePage,
      }))
    )
  );

  const StudentBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentBulkUpdatePage/StudentBulkUpdatePage").then((module) => ({
        default: module.StudentBulkUpdatePage,
      }))
    )
  );

  const StudentEmailPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentEmailPage/StudentEmailPage").then((module) => ({
        default: module.StudentEmailPage,
      }))
    )
  );

  const StudentBulkEmailPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentBulkEmailPage/StudentBulkEmailPage").then((module) => ({
        default: module.StudentBulkEmailPage,
      }))
    )
  );

  const StudentBulkAssignGroupPage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentBulkAssignGroupPage/StudentBulkAssignGroupPage").then((module) => ({
        default: module.StudentBulkAssignGroupPage,
      }))
    )
  );

  const StudentCreatePage = Loadable(
    lazy(() =>
      import("pages/students/students/StudentCreatePage/StudentCreatePage").then((module) => ({
        default: module.StudentCreatePage,
      }))
    )
  );

  const StudentEnrollmentListPage = Loadable(
    lazy(() =>
      import("pages/students/student-enrollments/StudentEnrollmentListPage/StudentEnrollmentListPage").then(
        (module) => ({
          default: module.StudentEnrollmentListPage,
        })
      )
    )
  );

  const StudentEnrollmentPage = Loadable(
    lazy(() =>
      import("pages/students/student-enrollments/StudentEnrollmentPage/StudentEnrollmentPage").then((module) => ({
        default: module.StudentEnrollmentPage,
      }))
    )
  );

  const StudentEnrollmentBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/students/student-enrollments/StudentEnrollmentBulkUpdatePage/StudentEnrollmentBulkUpdatePage").then(
        (module) => ({
          default: module.StudentEnrollmentBulkUpdatePage,
        })
      )
    )
  );

  const StudentGroupListPage = Loadable(
    lazy(() =>
      import("pages/students/student-groups/StudentGroupListPage/StudentGroupListPage").then((module) => ({
        default: module.StudentGroupListPage,
      }))
    )
  );

  const StudentApplicationPage = Loadable(
    lazy(() =>
      import("pages/students/student-applications/StudentApplicationPage/StudentApplicationPage").then((module) => ({
        default: module.StudentApplicationPage,
      }))
    )
  );

  const StudentApplicationListPage = Loadable(
    lazy(() =>
      import("pages/students/student-applications/StudentApplicationListPage/StudentApplicationListPage").then(
        (module) => ({
          default: module.StudentApplicationListPage,
        })
      )
    )
  );

  const StudentFileListPage = Loadable(
    lazy(() =>
      import("pages/students/student-files/StudentFileListPage/StudentFileListPage").then(
        (module) => ({
          default: module.StudentFileListPage,
        })
      )
    )
  );

  const StudentGroupPage = Loadable(
    lazy(() =>
      import("pages/students/student-groups/StudentGroupPage/StudentGroupPage").then((module) => ({
        default: module.StudentGroupPage,
      }))
    )
  );

  const StudentGroupBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/students/student-groups/StudentGroupBulkUpdatePage/StudentGroupBulkUpdatePage").then((module) => ({
        default: module.StudentGroupBulkUpdatePage,
      }))
    )
  );

  const StudentGradePage = Loadable(
    lazy(() =>
      import("pages/students/student-grades/StudentGradePage/StudentGradePage").then((module) => ({
        default: module.StudentGradePage,
      }))
    )
  );

  const StudentGradeBulkCreatePage = Loadable(
    lazy(() =>
      import("pages/students/student-grades/StudentGradeBulkCreatePage/StudentGradeBulkCreatePage").then((module) => ({
        default: module.StudentGradeBulkCreatePage,
      }))
    )
  );

  const StudentGpaPage = Loadable(
    lazy(() =>
      import("pages/students/student-gpas/StudentGpaPage/StudentGpaPage").then((module) => ({
        default: module.StudentGpaPage,
      }))
    )
  );

  const StudentAbsencePage = Loadable(
    lazy(() =>
      import("pages/students/student-absences/StudentAbsencePage/StudentAbsencePage").then((module) => ({
        default: module.StudentAbsencePage,
      }))
    )
  );

  const StudentTestPage = Loadable(
    lazy(() =>
      import("pages/students/student-tests/StudentTestPage/StudentTestPage").then((module) => ({
        default: module.StudentTestPage,
      }))
    )
  );

  const StudentDiplomaPage = Loadable(
    lazy(() =>
      import("pages/students/student-diplomas/StudentDiplomaPage/StudentDiplomaPage").then((module) => ({
        default: module.StudentDiplomaPage,
      }))
    )
  );

  const StudentPostHighSchoolPage = Loadable(
    lazy(() =>
      import("pages/students/student-post-high-schools/StudentPostHighSchoolPage/StudentPostHighSchoolPage").then(
        (module) => ({
          default: module.StudentPostHighSchoolPage,
        })
      )
    )
  );

  const StudentScholarshipPage = Loadable(
    lazy(() =>
      import("pages/students/student-scholarships/StudentScholarshipPage/StudentScholarshipPage").then((module) => ({
        default: module.StudentScholarshipPage,
      }))
    )
  );

  const StudentFafsaPage = Loadable(
    lazy(() =>
      import("pages/students/student-fafsas/StudentFafsaPage/StudentFafsaPage").then((module) => ({
        default: module.StudentFafsaPage,
      }))
    )
  );

  const StudentParentPage = Loadable(
    lazy(() =>
      import("pages/students/student-parents/StudentParentPage/StudentParentPage").then((module) => ({
        default: module.StudentParentPage,
      }))
    )
  );

  const CustomDataModelFieldListPage = Loadable(
    lazy(() =>
      import("pages/system/custom-data-model-fields/CustomDataModelFieldListPage/CustomDataModelFieldListPage").then(
        (module) => ({
          default: module.CustomDataModelFieldListPage,
        })
      )
    )
  );

  const CustomDataModelFieldPage = Loadable(
    lazy(() =>
      import("pages/system/custom-data-model-fields/CustomDataModelFieldPage/CustomDataModelFieldPage").then(
        (module) => ({
          default: module.CustomDataModelFieldPage,
        })
      )
    )
  );

  const StudentServicePage = Loadable(
    lazy(() =>
      import("pages/students/student-services/StudentServicePage/StudentServicePage").then((module) => ({
        default: module.StudentServicePage,
      }))
    )
  );

  const StudentServiceListPage = Loadable(
    lazy(() =>
      import("pages/students/student-services/StudentServiceListPage/StudentServiceListPage").then((module) => ({
        default: module.StudentServiceListPage,
      }))
    )
  );

  const StudentServiceBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/students/student-services/StudentServiceBulkUpdatePage/StudentServiceBulkUpdatePage").then(
        (module) => ({
          default: module.StudentServiceBulkUpdatePage,
        })
      )
    )
  );

  const StudentReportPage = Loadable(
    lazy(() =>
      import("pages/reports/StudentReportPage/StudentReportPage").then((module) => ({
        default: module.StudentReportPage,
      }))
    )
  );

  const StudentServiceIndexPage = Loadable(
    lazy(() =>
      import("pages/students/student-service-indexes/StudentServiceIndexPage/StudentServiceIndexPage").then(
        (module) => ({
          default: module.StudentServiceIndexPage,
        })
      )
    )
  );

  const StudentServiceIndexListPage = Loadable(
    lazy(() =>
      import("pages/students/student-service-indexes/StudentServiceIndexListPage/StudentServiceIndexListPage").then(
        (module) => ({
          default: module.StudentServiceIndexListPage,
        })
      )
    )
  );

  const StudentServiceTemplateListPage = Loadable(
    lazy(() =>
      import(
        "pages/students/student-service-templates/StudentServiceTemplateListPage/StudentServiceTemplateListPage"
      ).then((module) => ({
        default: module.StudentServiceTemplateListPage,
      }))
    )
  );

  const StudentServiceTemplatePage = Loadable(
    lazy(() =>
      import("pages/students/student-service-templates/StudentServiceTemplatePage/StudentServiceTemplatePage").then(
        (module) => ({
          default: module.StudentServiceTemplatePage,
        })
      )
    )
  );

  const StudentServiceTemplateSignUpPage = Loadable(
    lazy(() =>
      import(
        "pages/students/student-service-templates/StudentServiceTemplateSignUpPage/StudentServiceTemplateSignUpPage"
      ).then((module) => ({
        default: module.StudentServiceTemplateSignUpPage,
      }))
    )
  );

  const FinancialTablePage = Loadable(
    lazy(() =>
      import("pages/public-forms/applications/GUUtahFinancialTable").then((module) => ({
        default: module.FinancialTablePage,
      }))
    )
  );

  const HomelessDefinitionPage = Loadable(
    lazy(() =>
      import("pages/public-forms/applications/HomelessDefinition").then((module) => ({
        default: module.HomelessDefinitionPage,
      }))
    )
  );

  const UtilityPage = Loadable(
    lazy(() =>
      import("pages/system/utility/UtilityPage").then((module) => ({
        default: module.UtilityPage,
      }))
    )
  );

  const StudentLinkPage = Loadable(
    lazy(() =>
      import(
        "pages/students/student-service-templates/StudentServiceTemplatePage/StudentLinkPage/StudentLinkPage"
      ).then((module) => ({
        default: module.StudentLinkPage,
      }))
    )
  );

  const FileDetailPage = Loadable(
    lazy(() =>
      import("pages/students/student-applications/StudentApplicationPage/FileDetail/FileDetailPage").then((module) => ({
        default: module.FileDetailPage,
      }))
    )
  );
  const ScholarshipPaymentMethodListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipPaymentMethod/ScholarshipPaymentMethodListPage/ScholarshipPaymentMethodListPage").then((module) => ({
        default: module.ScholarshipPaymentMethodListPage,
      }))
    )
  );

  const ScholarshipPaymentMethodPage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipPaymentMethod/ScholarshipPaymentMethodPage/ScholarshipPaymentMethodPage").then((module) => ({
        default: module.ScholarshipPaymentMethodPage,
      }))
    )
  );

  const ScholarshipStatusListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipStatus/ScholarshipStatusListPage/ScholarshipStatusListPage").then((module) => ({
        default: module.ScholarshipStatusListPage,
      }))
    )
  );

  const ScholarshipStatusPage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipStatus/ScholarshipStatusPage/ScholarshipStatusPage").then((module) => ({
        default: module.ScholarshipStatusPage,
      }))
    )
  );

  const ScholarshipTypeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipTypes/ScholarshipTypeListPage/ScholarshipTypeListPage").then((module) => ({
        default: module.ScholarshipTypeListPage,
      }))
    )
  );

  const ScholarshipTypePage = Loadable(
    lazy(() =>
      import("pages/system/utility/scholarshipTypes/ScholarshipTypePage/ScholarshipTypePage").then((module) => ({
        default: module.ScholarshipTypePage,
      }))
    )
  );

  const SchoolListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/schools/SchoolListPage/SchoolListPage").then((module) => ({
        default: module.SchoolListPage,
      }))
    )
  );

  const SchoolPage = Loadable(
    lazy(() =>
      import("pages/system/utility/schools/SchoolPage/SchoolPage").then((module) => ({
        default: module.SchoolPage,
      }))
    )
  );

  const DistrictListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/districts/DistrictListPage/DistrictListPage").then((module) => ({
        default: module.DistrictListPage,
      }))
    )
  );

  const DistrictPage = Loadable(
    lazy(() =>
      import("pages/system/utility/districts/DistrictPage/DistrictPage").then((module) => ({
        default: module.DistrictPage,
      }))
    )
  );

  const FeederSchoolListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/feederSchools/FeederSchoolListPage/FeederSchoolListPage").then((module) => ({
        default: module.FeederSchoolListPage,
      }))
    )
  );
  const FeederSchoolPage = Loadable(
    lazy(() =>
      import("pages/system/utility/feederSchools/FeederSchoolPage/FeederSchoolPage").then((module) => ({
        default: module.FeederSchoolPage,
      }))
    )
  );

  const FileCategoryListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/fileCategories/FileCategoryListPage/FileCategoryListPage").then((module) => ({
        default: module.FileCategoryListPage,
      }))
    )
  );

  const FileCategoryPage = Loadable(
    lazy(() =>
      import("pages/system/utility/fileCategories/FileCategoryPage/FileCategoryPage").then((module) => ({
        default: module.FileCategoryPage,
      }))
    )
  );
  const IEPListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/iep/IEPListPage/IEPListPage").then((module) => ({
        default: module.IEPListPage,
      }))
    )
  );

  const IEPPage = Loadable(
    lazy(() =>
      import("pages/system/utility/iep/IEPPage/IEPPage").then((module) => ({
        default: module.IEPPage,
      }))
    )
  );
  const LEPListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/lep/LepListPage/LEPListPage").then((module) => ({
        default: module.LEPListPage,
      }))
    )
  );
  const LEPPage = Loadable(
    lazy(() =>
      import("pages/system/utility/lep/LepPage/LEPPage").then((module) => ({
        default: module.LEPPage,
      }))
    )
  );

  const ClassListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/Classes/ClassListPage/ClassListPage").then((module) => ({
        default: module.ClassListPage,
      }))
    )
  );

  const ClassPage = Loadable(
    lazy(() =>
      import("pages/system/utility/Classes/ClassPage/ClassPage").then((module) => ({
        default: module.ClassPage,
      }))
    )
  );

  const CollegeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/colleges/CollegeListPage/CollegeListPage").then((module) => ({
        default: module.CollegeListPage,
      }))
    )
  );

  const CollegePage = Loadable(
    lazy(() =>
      import("pages/system/utility/colleges/CollegePage/CollegePage").then((module) => ({
        default: module.CollegePage,
      }))
    )
  );
  const CohortListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/cohorts/CohortListPage/CohortListPage").then((module) => ({
        default: module.CohortListPage,
      }))
    )
  );
  const CohortPage = Loadable(
    lazy(() =>
      import("pages/system/utility/cohorts/CohortPage/CohortPage").then((module) => ({
        default: module.CohortPage,
      }))
    )
  );
  const EndReasonListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/endReasons/EndReasonListPage/EndReasonListPage").then((module) => ({
        default: module.EndReasonListPage,
      }))
    )
  );

  const EndReasonPage = Loadable(
    lazy(() =>
      import("pages/system/utility/endReasons/EndReasonPage/EndReasonPage").then((module) => ({
        default: module.EndReasonPage,
      }))
    )
  );

  const GradeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/grades/GradeListPage/GradeListPage").then((module) => ({
        default: module.GradeListPage,
      }))
    )
  );

  const GradePage = Loadable(
    lazy(() =>
      import("pages/system/utility/grades/GradePage/GradePage").then((module) => ({
        default: module.GradePage,
      }))
    )
  );

  const RegionListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/regions/RegionListPage/RegionListPage").then((module) => ({
        default: module.RegionListPage,
      }))
    )
  );

  const RegionPage = Loadable(
    lazy(() =>
      import("pages/system/utility/regions/RegionPage/RegionPage").then((module) => ({
        default: module.RegionPage,
      }))
    )
  );

  const StudentServiceTypeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/studentServiceTypes/StudentServiceTypeListPage/StudentServiceTypeListPage").then(
        (module) => ({
          default: module.StudentServiceTypeListPage,
        })
      )
    )
  );

  const StudentServiceTypePage = Loadable(
    lazy(() =>
      import("pages/system/utility/studentServiceTypes/StudentServiceTypePage/StudentServiceTypePage").then(
        (module) => ({
          default: module.StudentServiceTypePage,
        })
      )
    )
  );

  const StaffPositionListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/staffPosition/StaffPositionListPage/StaffPositionListPage").then(
        (module) => ({
          default: module.StaffPositionListPage,
        })
      )
    )
  );

  const StaffPositionPage = Loadable(
    lazy(() =>
      import("pages/system/utility/staffPosition/StaffPositionPage/StaffPositionPage").then((module) => ({
        default: module.StaffPositionPage,
      }))
    )
  );

  const StaffServiceTypeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/staffServiceTypes/StaffServiceTypeListPage/StaffServiceTypeListPage").then(
        (module) => ({
          default: module.StaffServiceTypeListPage,
        })
      )
    )
  );

  const StaffServiceTypePage = Loadable(
    lazy(() =>
      import("pages/system/utility/staffServiceTypes/StaffServiceTypePage/StaffServiceTypePage").then((module) => ({
        default: module.StaffServiceTypePage,
      }))
    )
  );

  const DiplomaTypeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/diplomaTypes/DiplomaTypeListPage/DiplomaTypeListPage").then((module) => ({
        default: module.DiplomaTypeListPage,
      }))
    )
  );

  const DiplomaTypePage = Loadable(
    lazy(() =>
      import("pages/system/utility/diplomaTypes/DiplomaTypePage/DiplomaTypePage").then((module) => ({
        default: module.DiplomaTypePage,
      }))
    )
  );

  const TopicListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/topics/TopicListPage/TopicListPage").then((module) => ({
        default: module.TopicListPage,
      }))
    )
  );

  const TopicPage = Loadable(
    lazy(() =>
      import("pages/system/utility/topics/TopicPage/TopicPage").then((module) => ({
        default: module.TopicPage,
      }))
    )
  );

  const TestTypeListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/TestTypes/TestTypesListPage/TestTypeListPage").then((module) => ({
        default: module.TestTypeListPage,
      }))
    )
  );

  const TestTypePage = Loadable(
    lazy(() =>
      import("pages/system/utility/TestTypes/TestTypesPage/TestTypePage").then((module) => ({
        default: module.TestTypePage,
      }))
    )
  );

  const DisciplineListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/disciplines/DisciplineListPage/DisciplineListPage").then((module) => ({
        default: module.DisciplineListPage,
      }))
    )
  );

    const DisciplinePage = Loadable(
        lazy(() =>
            import("pages/system/utility/disciplines/DisciplinePage/DisciplinePage").then((module) => ({
                default: module.DisciplinePage,
            }))
        )
    );
    const PostHSPlanStatusListPage = Loadable(
        lazy(() =>
            import("pages/system/utility/postHSPlanStatus/PostHSPlanStatusPage/PostHSPlanStatusListPage").then((module) => ({
                default: module.PostHSPlanStatusListPage,
            }))
        )
    );

    const PostHSPlanStatusPage = Loadable(
        lazy(() =>
            import("pages/system/utility/postHSPlanStatus/PostHSPlanStatus/PostHSPlanStatus").then((module) => ({
                default: module.PostHSPlanStatusPage,
            }))
        )
    );

  const ProviderListPage = Loadable(
    lazy(() =>
      import("pages/providers/providers/ProviderListPage/ProviderListPage").then((module) => ({
        default: module.ProviderListPage,
      }))
    )
  );

  const ProviderPage = Loadable(
    lazy(() =>
      import("pages/providers/providers/ProviderPage/ProviderPage").then((module) => ({
        default: module.ProviderPage,
      }))
    )
  );

  const ProviderCreatePage = Loadable(
    lazy(() =>
      import("pages/providers/providers/ProviderCreatePage/ProviderCreatePage").then((module) => ({
        default: module.ProviderCreatePage,
      }))
    )
  );

  const ProviderEmploymentPage = Loadable(
    lazy(() =>
      import("pages/providers/provider-employments/ProviderEmploymentPage/ProviderEmploymentPage").then((module) => ({
        default: module.ProviderEmploymentPage,
      }))
    )
  );

  const ProviderPositionListPage = Loadable(
    lazy(() =>
      import("pages/system/utility/providerPositions/ProviderPositionListPage/ProviderPositionListPage").then(
        (module) => ({
          default: module.ProviderPositionListPage,
        })
      )
    )
  );

  const ProviderPositionPage = Loadable(
    lazy(() =>
      import("pages/system/utility/providerPositions/ProviderPositionPage/ProviderPositionPage").then(
        (module) => ({
          default: module.ProviderPositionPage,
        })
      )
    )
  );

  const AprPage = Loadable(
    lazy(() =>
      import("pages/ed-reports/AprPage/AprPage").then((module) => ({
        default: module.AprPage,
      }))
    )
  );

  const AprTrioPage = Loadable(
    lazy(() =>
      import("pages/ed-reports/AprTrio/AprTrioPage").then((module) => ({
        default: module.AprTrioPage,
      }))
    )
  );

  const AprEtsPage = Loadable(
    lazy(() =>
      import("pages/ed-reports/AprEts/AprEtsPage").then((module) => ({
        default: module.AprEtsPage,
      }))
    )
  );

  const AprEocPage = Loadable(
    lazy(() =>
      import("pages/ed-reports/AprEoc/AprEocPage").then((module) => ({
        default: module.AprEocPage,
      }))
    )
  );

  const AprUbPage = Loadable(
    lazy(() =>
      import("pages/ed-reports/AprUb/AprUbPage").then((module) => ({
        default: module.AprUbPage,
      }))
    )
  );

  const StaffServiceListPage = Loadable(
    lazy(() =>
      import("pages/staff/staff-services/StaffServiceListPage/StaffServiceListPage").then((module) => ({
        default: module.StaffServiceListPage,
      }))
    )
  );

  const StaffServicePage = Loadable(
    lazy(() =>
      import("pages/staff/staff-services/StaffServicePage/StaffServicePage").then((module) => ({
        default: module.StaffServicePage,
      }))
    )
  );

  const StaffServiceBulkUpdatePage = Loadable(
    lazy(() =>
      import("pages/staff/staff-services/StaffServiceBulkUpdatePage/StaffServiceBulkUpdatePage").then((module) => ({
        default: module.StaffServiceBulkUpdatePage,
      }))
    )
  );

  const StaffEmploymentPage = Loadable(
    lazy(() =>
      import("pages/staff/staff-employments/StaffEmploymentPage/StaffEmploymentPage").then((module) => ({
        default: module.StaffEmploymentPage,
      }))
    )
  );

  const StaffCreatePage = Loadable(
    lazy(() =>
      import("pages/staff/staff/StaffCreatePage/StaffCreatePage").then((module) => ({
        default: module.StaffCreatePage,
      }))
    )
  );

  const StaffBulkCreateServicesPage = Loadable(
    lazy(() =>
      import("pages/staff/staff/StaffBulkCreateServicesPage/StaffBulkCreateServicesPage").then((module) => ({
        default: module.StaffBulkCreateServicesPage,
      }))
    )
  );

  const StaffReportPage = Loadable(
    lazy(() =>
      import("pages/reports/StaffReportPage/StaffReportPage").then((module) => ({
        default: module.StaffReportPage,
      }))
    )
  );

  const TextingConversationsPage = Loadable(
    lazy(() =>
      import("pages/texting/TextingConversationsPage/TextingConversationsPage").then((module) => ({
        default: module.TextingConversationsPage,
      }))
    )
  );

  const CreateTextingConversationsPage = Loadable(
    lazy(() =>
      import("pages/texting/CreateTextingConversationsPage/CreateTextingConversationsPage").then((module) => ({
        default: module.CreateTextingConversationsPage,
      }))
    )
  );


  return {
    CreateTextingConversationsPage,
    TextingConversationsPage,
    StaffBulkCreateServicesPage,
    StaffCreatePage,
    StaffEmploymentPage,
    StaffServiceBulkUpdatePage,
    StaffListPage,
    StaffPage,
    StaffServiceListPage,
    StaffServicePage,
    NscCollegePage,
    AprPage,
    AprTrioPage,
    AprEtsPage,
    AprEocPage,
    AprUbPage,
    ApplicationListPage,
    ApplicationPage,
    ClassListPage,
    ClassPage,
    CohortListPage,
    CohortPage,
    CollegeListPage,
    CollegePage,
    ContributorBulkCreateMatchesPage,
    ContributorBulkMergePage,
    ContributorCreatePage,
    ContributorEmploymentPage,
    ContributorListPage,
    ContributorMatchBulkUpdatePage,
    ContributorMatchListPage,
    ContributorMatchPage,
    ContributorMatchServiceListPage,
    ContributorMatchServicePage,
    ContributorPage,
    CustomDataModelFieldListPage,
    CustomDataModelFieldPage,
    DashboardReportPage,
    DataCenterFileCreatePage,
    DataCenterFileListPage,
    DataCenterFileViewPage,
    DeveloperBulkUpdatePage,
    DeveloperListPage,
    DeveloperPage,
    DiplomaTypeListPage,
    DiplomaTypePage,
    DisciplineListPage,
    DisciplinePage,
    DistrictListPage,
    DistrictPage,
    FeederSchoolListPage,
    FeederSchoolPage,
    FileCategoryListPage,
    FileCategoryPage,
    IEPListPage,
    IEPPage,
    PostHSPlanStatusPage,
    PostHSPlanStatusListPage,
    LEPListPage,
    LEPPage,
    EndReasonListPage,
    EndReasonPage,
    GradeListPage,
    GradePage,
    ExportPage,
    ObjectiveReportPage,
    FinancialTablePage,
    ForgotCredentialPage,
    ForgotCredentialPageV2,
    HomelessDefinitionPage,
    HomePage,
    LoginPage,
    LoginPageV2,
    MatchReportPage,
    NonPersonnelListPage,
    NonPersonnelPage,
    PartnerCreatePage,
    PartnerIndirectCostPage,
    PartnerListPage,
    PartnerPage,
    ProviderCreatePage,
    ProviderEmploymentPage,
    ProviderListPage,
    ProviderPage,
    ProviderPositionListPage,
    ProviderPositionPage,
    PublicApplicationPage,
    PublicSurveyPage,
    RegionListPage,
    RegionPage,
    ResetPasswordPage,
    ScholarshipPaymentMethodListPage,
    ScholarshipPaymentMethodPage,
    ScholarshipStatusListPage,
    ScholarshipStatusPage,
    ScholarshipTypeListPage,
    ScholarshipTypePage,
    SchoolListPage,
    SchoolPage,
    StudentAbsencePage,
    StudentApplicationPage,
    StudentApplicationListPage,
    StudentBulkAssignGroupPage,
    StudentBulkCreateServicesPage,
    StudentBulkUpdatePage,
    StudentEmailPage,
    StudentBulkEmailPage,
    StudentCreatePage,
    StudentDiplomaPage,
    StudentPostHighSchoolPage,
    StudentEnrollmentBulkUpdatePage,
    StudentEnrollmentListPage,
    StudentEnrollmentPage,
    StudentFafsaPage,
    StudentGpaPage,
    StudentGradeBulkCreatePage,
    StudentGradePage,
    StudentGroupBulkUpdatePage,
    StudentGroupListPage,
    StudentGroupPage,
    StudentLinkPage,
    FileDetailPage,
    StudentListPage,
    StudentPage,
    StudentParentPage,
    StudentReportPage,
    SurveyResponseStudentPage,
    StudentScholarshipPage,
    StudentServiceBulkUpdatePage,
    StudentServiceListPage,
    StudentServicePage,
    StudentServiceIndexPage,
    StudentServiceIndexListPage,
    StudentServiceTemplateListPage,
    StudentServiceTemplatePage,
    StudentServiceTemplateSignUpPage,
    StudentServiceTypeListPage,
    StudentServiceTypePage,
    StaffPositionListPage,
    StaffPositionPage,
    StaffServiceTypeListPage,
    StaffServiceTypePage,
    StudentTestPage,
    SubPartnerPage,
    SuppliesDetailListPage,
    SuppliesDetailPage,
    SurveyExportPage,
    CobroSurveyExportPage,
    SurveyListPage,
    SurveyReportListPage,
    SurveyReportPage,
    SurveyReportReportPage,
    SurveyPage,
    SurveyResponseListPage,
    TestPage,
    ThankYouPage,
    TopicListPage,
    TopicPage,
    TestTypeListPage,
    TestTypePage,
    The404Page,
    UserListPage,
    UserManualPage,
    UserPage,
    UserRegisterPage,
    UserRegisterPageV2,
    UtilityPage,
    StudentBulkMergePage,
    StaffReportPage,
  };
};
